import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface InlineSearchProps {
  initialValue?: string;
  tone?: "dark" | "light";
  placeholder?: string;
}

export default function InlineSearch({
  initialValue = "",
  tone = "light",
  placeholder = "输入作品名称、导演或演员",
}: InlineSearchProps) {
  const [keyword, setKeyword] = useState(initialValue);
  const navigate = useNavigate();

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
  };

  const isDark = tone === "dark";

  return (
    <form
      onSubmit={submit}
      className={`flex items-center gap-2 rounded-md border p-1.5 ${
        isDark
          ? "border-background-50/20 bg-background-50/10 backdrop-blur-sm"
          : "border-background-300 bg-background-50"
      }`}
    >
      <i className={`ri-search-line ml-1.5 text-sm ${isDark ? "text-background-300" : "text-foreground-500"}`} />
      <input
        value={keyword}
        onChange={(event) => setKeyword(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视作品"
        className={`min-w-0 flex-1 bg-transparent py-2 text-sm outline-none ${
          isDark
            ? "text-background-50 placeholder:text-background-400"
            : "text-foreground-900 placeholder:text-foreground-400"
        }`}
      />
      <button
        type="submit"
        className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-sm bg-accent-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer"
      >
        搜索
        <i className="ri-arrow-right-line" />
      </button>
    </form>
  );
}